import { oneLine } from 'common-tags';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var UuidKey = 'dd-post-message-uuid';
var generateUuid = function generateUuid() {
  return (Math.random() + 1).toString(36).substr(7);
};
var createMessage = function createMessage(data, uuid) {
  var _ref;

  return _ref = {}, _ref[UuidKey] = uuid, _ref.data = data, _ref;
};

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["Origins do not match for incoming MessageEvent. Expected origin: ", ",\n            event origin: ", ". Ignoring event."]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Listener = /*#__PURE__*/function () {
  function Listener(target, origin, handlers, host) {
    var _this = this;

    if (handlers === void 0) {
      handlers = [];
    }

    if (host === void 0) {
      host = window;
    }

    this.target = target;
    this.origin = origin;
    this.handlers = handlers;
    this.host = host;

    this.handleMessageReceived = function (event) {
      if (process.env.NODE_ENV === 'production') {
        // Need to hide this check development because event.origin is always an empty string
        if (event.origin !== _this.origin) {
          console.warn(oneLine(_templateObject(), _this.origin, event.origin));
          return;
        }
      }

      var uuid = event.data[UuidKey];
      var data = event.data.data;

      if (uuid == null) {
        console.warn('Event does not contain a valid messageId. Ignoring event.');
        return;
      }

      if (data == null) {
        console.warn('Event does not have a data property. Ignoring event.');
        return;
      }

      var handler = _this.handlers.find(function (it) {
        return it.test(data);
      });

      if (handler == null) {
        console.warn('Event does not have a registered handler. Ignoring event.');
        return;
      }

      var message = handler.handle(data);

      if (message.then != null && typeof message.then === 'function') {
        message.then(function (res) {
          return _this.sendResponse(res, uuid);
        });
        return;
      }

      _this.sendResponse(message, uuid);
    };
  }

  var _proto = Listener.prototype;

  _proto.start = function start() {
    this.host.addEventListener('message', this.handleMessageReceived);
  };

  _proto.stop = function stop() {
    this.host.removeEventListener('message', this.handleMessageReceived);
  };

  _proto.addHandler = function addHandler(handler) {
    if (this.handlers.includes(handler)) {
      return;
    }

    this.handlers.push(handler);
  };

  _proto.removeHandler = function removeHandler(handler) {
    if (!this.handlers.includes(handler)) {
      return;
    }

    this.handlers = this.handlers.filter(function (it) {
      return it !== handler;
    });
  };

  _proto.removeAllHandlers = function removeAllHandlers() {
    this.handlers = [];
  };

  _proto.sendResponse = function sendResponse(data, requestUuid) {
    var message = createMessage(data, requestUuid);
    this.target.postMessage(message, this.origin);
  };

  return Listener;
}();

var Requester = /*#__PURE__*/function () {
  function Requester(target, origin, host, responseTimeout) {
    if (host === void 0) {
      host = window;
    }

    if (responseTimeout === void 0) {
      responseTimeout = 10000;
    }

    this.target = target;
    this.origin = origin;
    this.host = host;
    this.responseTimeout = responseTimeout;
  }

  var _proto = Requester.prototype;

  _proto.setResponseTimeout = function setResponseTimeout(timeout) {
    this.responseTimeout = timeout;
  };

  _proto.postMessage = function postMessage(data) {
    var _this = this;

    var requestUuid = generateUuid();
    var message = createMessage(data, requestUuid);
    var promise = new Promise(function (resolve, reject) {
      var handler = function handler(event) {
        if (process.env.NODE_ENV === 'production') {
          // Need to hide this check development because event.origin is always an empty string
          if (event.origin !== _this.origin) {
            return;
          }
        }

        var responseUuid = event.data[UuidKey];

        if (responseUuid == null || responseUuid !== requestUuid) {
          return;
        }

        resolve(event.data.data);

        _this.host.removeEventListener('message', handler);
      };

      _this.host.addEventListener('message', handler);

      setTimeout(function () {
        _this.host.removeEventListener('message', handler);

        reject(new Error('Request timed out'));
      }, _this.responseTimeout);
    });
    this.target.postMessage(message, this.origin);
    return promise;
  };

  return Requester;
}();

export { Listener, Requester };
